<script lang="ts" setup>
const { t: $t } = useI18n()

import type { ApiTrackerSensorGetByMachineryId } from '~/types'

const props = defineProps<{
  machineryId: string
}>()

const { trackerSensor: trackerSensorQuery } = useQuery()
const { data: trackerSensor } = trackerSensorQuery.getByMachineryId(props.machineryId)

const trackerSensorLocation = computed(() => {
  if (!trackerSensor.value) {
    return undefined
  }

  const dataPoints = trackerSensor.value.dataPoints

  if (dataPoints && dataPoints.length > 0) {
    return {
      lat: dataPoints[0].latitude,
      lng: dataPoints[0].longitude,
    }
  }

  return undefined
})

const mapKey = computed(() => trackerSensor.value?.id || 'default')

const columns: OneDataColumn<ApiTrackerSensorGetByMachineryId>[] = [
  {
    title: $t('machinery.details.trackerSensor.assignedSensor'),
    key: 'id',
  },
  {
    title: $t('machinery.details.trackerSensor.assignedSensorConfiguration'),
    key: 'configuration',
    render: ({ configuration }) => configuration ? `${configuration.id} - ${configuration.title}` : 'N/A',
    isVisible: ({ configuration }) => !!configuration,
  },
]
</script>

<template>
  <div class="flex flex-col gap-2">
    <p v-if="!trackerSensor">
      {{ $t('machinery.details.trackerSensor.noSensorAssigned') }}
    </p>
    <TableOneDataColumn v-else :config="{ columns, data: trackerSensor }" />
    <template v-if="trackerSensorLocation">
      <ClientOnly>
        <MapView
          :key="mapKey"
          :center="trackerSensorLocation"
          :marker="trackerSensorLocation"
          :zoom="15"
          :min-zoom="4"
          :max-zoom="18"
          :bound-radius-in-meters="500"
          :style="{ height: '300px', width: '100%' }"
        />
      </ClientOnly>
    </template>
  </div>
</template>
